import Sticky from 'sticky-js'
import 'waypoints/lib/noframework.waypoints.min.js';

import './components/parallax'
import './components/slider'

const titles = document.querySelectorAll('.text-section__copy h2:first-child')
const stats = document.querySelectorAll('.text-section__stat')

titles.forEach(el => {
  new Waypoint({
    element: el,
    handler: () => {
      el.classList.add('active')
    },
    offset: '90%'
  })
})

stats.forEach(el => {
  new Waypoint({
    element: el,
    handler: () => {
      el.classList.add('active')
    },
    offset: '45%'
  })
})

new Sticky('.sticky')